// extracted by mini-css-extract-plugin
export default {"container":"CreateOrganizationPage_container__zQ0O+","form":"CreateOrganizationPage_form__VxBja"};